import React from 'react';
import {
  cameraTypeList,
  tenDollarBundleDiscountOption
} from '../../utils/constant';
import { disableOptions } from '../vulcanPricing/utils/utils';
import { secureBusinessOffersVulcan } from '../vulcanPricing/secureBusiness/secureBusinessFieldNames';
import { getFieldValue } from '../utils';

// This function takes opt arguments which are equipment section fields
export const getControlIncludedCameraTotal = opt => {
  let returnObj = 0;
  const formObjectKeys = Object.keys(opt);
  const sectionSum = formObjectKeys
    .filter(k => cameraTypeList.includes(opt[k].productType))
    .reduce((acc, k) => acc + parseInt(opt[k].value || 0, 10), 0);
  returnObj = sectionSum;

  return returnObj; // Ensure returnObj is always returned
};

export const SecureBusinessHelpers = ({ fieldName, formFields }) => {
  if (fieldName === secureBusinessOffersVulcan) {
    if (!formFields[secureBusinessOffersVulcan].value) {
      formFields[secureBusinessOffersVulcan].value = [
        tenDollarBundleDiscountOption
      ];
    }
    disableOptions(
      formFields[secureBusinessOffersVulcan].options,
      [tenDollarBundleDiscountOption],
      true
    );
  }
};
